import { useMemo } from "react";

import { Line, LoadingSpinner } from "@sorcery/ui";
import { sortDistributors } from "@sorcery/utils/universal/sorting";

import { Distributor } from "~/components/molecules/Distributor";
import { api } from "~/utils/trpc";

export const BecomeARetailerDistributorsTab = () => {
  const { data: distributors, isLoading } = api.location.getDistributors.useQuery();
  const sortedDistributors = useMemo(() => sortDistributors(distributors ?? []), [distributors]);

  return (
    <div className="duration-1000 animate-in fade-in">
      {isLoading ? (
        <div className="mx-4 mb-80 mt-4 flex justify-center lg:justify-start">
          <LoadingSpinner />
        </div>
      ) : (
        <>
          {sortedDistributors.map((d) => (
            <div key={d.id}>
              <Distributor
                distributor={d}
                large={true}
                className="hover:!text-primary text-white transition-all duration-300 hover:scale-[1.02] hover:opacity-50"
              />
              <Line className="my-2" />
            </div>
          ))}
        </>
      )}
    </div>
  );
};
